import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import StripeBillingPortalSessionResource, {
  StripeBillingPortalSessionResource as ResourceClass
} from '@/modules/billing/resources/StripeBillingPortalSessionResource';
import { StripeBillingPortalSession } from '@/modules/billing/models/stripe/StripeBillingPortalSession';
import DocumentUIService from '@/modules/core/app/services/DocumentUIService';

export class StripeBillingPortalSessionService extends BaseService {
  resource: ResourceClass;

  constructor() {
    super();

    this.resource = StripeBillingPortalSessionResource;
  }

  async startSession(returnUrl?: string): Promise<void> {
    const session: StripeBillingPortalSession = await this.createSession(
      returnUrl ?? DocumentUIService.getUrl()
    );

    DocumentUIService.openUrl(session.url, '_self');
  }

  private createSession(returnUrl: string): Promise<StripeBillingPortalSession> {
    return this.resource.createSession(returnUrl);
  }
}

export default new StripeBillingPortalSessionService();
